import MyPOsConstants from '@/store/modules/myPOs/constants';

export default {
  [MyPOsConstants.mutationTypes.setMyPurchaseOrders](state, myPOs) {
    const localState = state;

    localState.myPOs = myPOs;
  },
  [MyPOsConstants.mutationTypes.setIsLoading](state, value) {
    const localState = state;

    localState.isLoading = value;
  },
  [MyPOsConstants.mutationTypes.setMyPurchaseOrdersTotal](state, value) {
    const localState = state;

    localState.myPOsTotal = value;
  },

  [MyPOsConstants.mutationTypes.setPaginationInfoPageNumber](state, value) {
    const localState = state;

    localState.paginationInfo.pageNumber = value;
  },

  [MyPOsConstants.mutationTypes.setPaginationInfoPageSize](state, value) {
    const localState = state;

    localState.paginationInfo.pageSize = value;
  },

  [MyPOsConstants.mutationTypes.setPaginationInfoSortBy](state, value) {
    const localState = state;

    localState.paginationInfo.sortBy = value;
  },

  [MyPOsConstants.mutationTypes.setPaginationInfoSortOrder](state, value) {
    const localState = state;

    localState.paginationInfo.sortOrder = value;
  },

  [MyPOsConstants.mutationTypes.setFilterQuery](state, value) {
    const localState = state;

    localState.filterQuery = value;
  },
};
